export default "__VITE_ASSET__DzjGk4SG__"